import {Inject, Injectable, Optional} from '@angular/core';
import {
  TRANSLOCO_CONFIG,
  TRANSLOCO_FALLBACK_STRATEGY,
  TRANSLOCO_INTERCEPTOR, TRANSLOCO_LOADER,
  TRANSLOCO_MISSING_HANDLER, TRANSLOCO_TRANSPILER,
  TranslocoConfig,
  TranslocoFallbackStrategy,
  TranslocoInterceptor,
  TranslocoLoader,
  TranslocoMissingHandler,
  TranslocoTranspiler
} from "@jsverse/transloco";
import {StateService} from "./state.service";
import {BaseTranslocoWithKeyService, GLOBAL} from "common-shared";

@Injectable({
  providedIn: 'root'
})
export class TranslocoWithKeyService extends BaseTranslocoWithKeyService {

  constructor(
    @Optional() @Inject(TRANSLOCO_LOADER) loader: TranslocoLoader,
    @Inject(TRANSLOCO_TRANSPILER) parser: TranslocoTranspiler,
    @Inject(TRANSLOCO_MISSING_HANDLER) missingHandler: TranslocoMissingHandler,
    @Inject(TRANSLOCO_INTERCEPTOR) interceptor: TranslocoInterceptor,
    @Inject(TRANSLOCO_CONFIG) userConfig: TranslocoConfig,
    @Inject(TRANSLOCO_FALLBACK_STRATEGY) fallbackStrategy: TranslocoFallbackStrategy,
    private state: StateService
  ) {
    super(loader, parser, missingHandler, interceptor, userConfig, fallbackStrategy);

    this.state.currentUser$.subscribe(value => {
      if (value) {
        this.setActiveLang(this.ensureAvailableLang(value.Language.Text));
        this.hasTranslationKeysInUi = value.Privileges.includes(GLOBAL.Privileges.TranslationKeysInUi) || localStorage.getItem('Show-Translation-Keys') == 'true';
        return this.hasEditLocalizationRole = value.Privileges.includes(GLOBAL.Privileges.EditLocalization);
      }
    });
  }
}
